// extracted by mini-css-extract-plugin
export var chip = "_58-0";
export var filterDropdown = "_58-5";
export var filterItem = "_58-6";
export var icon = "_58-1";
export var removeButton = "_58-3";
export var removeIcon = "_58-4";
export var separator = "_58-2";